<template>
  <div>
    <el-tabs v-model="paneIndex" type="card" @tab-click="handleClick">
      <el-tab-pane label="集团配置" name="reserve">
        <el-row :gutter="16" type="flex" justify="space-around">
          <el-col :span="8">
            <el-card class="box-card" style="width: 500px;">
              <div slot="header" class="clearfix">
                <span>预留金额</span>
                <el-button
                  style="float: right; padding: 10px 0"
                  type="text"
                  @click="handleUpdate"
                >修改</el-button>
              </div>
              <div class="text item">
                <div style="height: 200px;text-align: center;">
                  <el-row>
                    <el-col>&nbsp;</el-col>
                  </el-row>
                  <el-row>
                    <el-col>&nbsp;</el-col>
                  </el-row>
                  <el-row>
                    <el-col>&nbsp;</el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <h1>
                        <a style="color: red">{{ amount }}</a> 元
                      </h1>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card" style="width: 500px;">
              <div slot="header" class="clearfix">
                <span>短信设置</span>
                <el-button style="float: right; padding: 10px 0" type="text" @click="handleSet">设置</el-button>
              </div>
              <div class="text item">
                <div style="height: 200px;text-align: center;">
                  <el-row>
                    <el-col>&nbsp;</el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <h3>剩余短信条数：{{ surplus }}</h3>
                    </el-col>
                    <el-row>
                      <el-col>
                        <h3>加油发送短信：{{ smsFuel=== '1' ? '允许' : '不允许' }}</h3>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <h3>充值发送短信：{{ smsRecharge === '1' ? '允许' : '不允许' }}</h3>
                      </el-col>
                    </el-row>
                  </el-row>
                  <el-row>
                    <el-col>&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="16" type="flex" justify="space-around">
          <el-col :span="8">
            <el-card class="box-card" style="width: 500px;">
              <div slot="header" class="clearfix">
                <span>优惠设置</span>
                <el-button
                  style="float: right; padding: 10px 0"
                  type="text"
                  @click="handleUpdateCalcType"
                >修改</el-button>
              </div>
              <div class="text item">
                <div style="height: 200px;text-align: center;">
                  <el-row>
                    <el-col>&nbsp;</el-col>
                  </el-row>
                  <el-row>
                    <el-col>&nbsp;</el-col>
                  </el-row>
                  <el-row>
                    <el-col>&nbsp;</el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <h3>
                        按照加油升数<a style="color: red">{{calcType | calcTypeFilter}}</a>计算会员优惠
                      </h3>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      v-if="dialogReserve"
      :visible.sync="dialogReserve"
      :close-on-click-modal="false"
      title="修改-预留金额"
      width="400px"
    >
      <el-input v-model="tempReserve" placeholder="请输入预留金额" clearable>
        <template slot="prepend">预留金额：</template>
      </el-input>
      <p v-if="!inputCurrent" style="text-align: center;color: red">* 请输入正确的预留金额(0-100)</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogReserve = false">取 消</el-button>
        <el-button type="primary" @click="updateData">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogSms" title="短信配置" width="35%">
      <div style="text-align: center">
        <el-row type="flex" justify="space-around">
          <el-col :span="12">
            <el-form :model="smsForm">
              <el-form-item label="允许充值发送短信：" label-width="150">
                <el-radio-group v-model="smsForm.smsRecharge">
                  <el-radio label="1">允许</el-radio>
                  <el-radio label="0">不允许</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="允许加油发送短信：" label-width="150">
                <el-radio-group v-model="smsForm.smsFuel">
                  <el-radio label="1">允许</el-radio>
                  <el-radio label="0">不允许</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSms = false">取 消</el-button>
        <el-button type="primary" @click="confirmSet">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogCalcType" title="优惠设置" width="35%">
      <div style="text-align: center">
        <el-row justify="space-around">
          <el-col :span="12">
            <el-form :model="calcTypeForm">
              <el-form-item label-width="150">
                <el-radio-group v-model="calcTypeForm.type" title="优惠方式">
                  <el-row type="flex" justify="space-around">
                    <el-col :span="11">
                      <el-radio label="0">按照加油升数整数位计算会员优惠</el-radio>
                    </el-col>
                    <el-col :span="2">
                      &nbsp;
                    </el-col>
                    <el-col :span="11">
                      <el-radio label="1">按照加油升数完整数计算会员优惠</el-radio>
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCalcType = false">取 消</el-button>
        <el-button type="primary" @click="confirmSetCalcType">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import countTo from 'vue-count-to';
import {
  getReserve,
  updateReserve,
  setSmsSetting,
  getSmsSetting,
  getSmsStock,
  setCalcTypeSetting
} from '../../api/setting';
import { getUserPermissions } from '@/utils/auth';

export default {
  name: 'Reserve',
  components: { countTo },
  data () {
    return {
      paneIndex: 'reserve',
      amount: 0,
      dialogReserve: false,
      dialogSms: false,
      dialogCalcType: false,
      tempReserve: 10,
      inputCurrent: false,
      smsRecharge: '0',
      smsFuel: '0',
      surplus: 0,
      smsForm: {
        smsFuel: '0',
        smsRecharge: '0'
      },
      calcType: 0, // 优惠计算方式,
      calcTypeForm: {
        type: '0'
      }
    }
  },
  created () {
    this.getAmt()
    this.getSmsSet()
    this.getSms()
  },
  filters:{
    calcTypeFilter(type){
      let typeValue = '整数位'
      if (type === 0){
        typeValue = '整数位'
      } else if(type === 1){
        typeValue = '完整数'
      }
      return typeValue
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    getAmt () {
      getReserve({}).then(resp => {
        const amt = resp.data.data.amt
        // amt = Math.floor(amt * 100) / 100
        this.amount = amt.toFixed(2)
      //  优惠计算方式
        this.calcType = resp.data.data.calcType
        this.calcTypeForm.type = resp.data.data.calcType + ''
      })
    },
    getSmsSet () {
      getSmsSetting({})
        .then(res => {
          const data = res.data.data
          this.smsFuel = this.smsForm.smsFuel = data.smsFuel
            ? data.smsFuel + ''
            : '0';
          this.smsRecharge = this.smsForm.smsRecharge = data.smsRecharge
            ? data.smsRecharge + ''
            : '0';
        })
        .catch(e => {
          this.$notify({
            title: '错误',
            message: '获取短信配置失败！原因：' + e,
            type: 'error'
          })
        })
    },
    getSms () {
      getSmsStock({}).then(res => {
        const data = res.data.data
        this.surplus = data.surplusNumber ? data.surplusNumber : 0
      })
    },
    handleUpdate () {
      if (!getUserPermissions('GROUP_RESERVE_AMT')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
      } else {
        this.tempReserve = 0
        this.dialogReserve = true
      }
    },
    updateData () {
      let number = Number.parseFloat(this.tempReserve)
      if (Number.isNaN(number)) {
        this.inputCurrent = false
        number = 0
      } else {
        this.inputCurrent = true
      }
      if (number < 0 || number > 100) {
        this.inputCurrent = false
      } else {
        this.inputCurrent = true
      }
      if (!this.inputCurrent) {
        return
      }
      number = Math.floor(number * 100) / 100
      this.tempReserve = number
      updateReserve({ amt: this.tempReserve }).then(resp => {
        this.getAmt()
        this.dialogReserve = false
      })
    },
    handleSet () {
      this.getSmsSet()
      this.dialogSms = true
    },
    confirmSet () {
      setSmsSetting(this.smsForm).then(() => {
        this.dialogSms = false
        this.freshAllData()
        this.$notify({
          title: '成功',
          message: '修改成功！',
          type: 'success'
        })
      })
    },
    freshAllData () {
      this.getAmt()
      this.getSmsSet()
      this.getSms()
    },
    handleUpdateCalcType () {
        if (!getUserPermissions('GROUP_RESERVE_AMT')) {
          this.$notify({
            title: '错误',
            message: '抱歉，你没有权限，请联系管理员开通',
            type: 'error'
          })
        } else {
          this.dialogCalcType = true
        }
    },
    confirmSetCalcType () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setCalcTypeSetting(this.calcTypeForm).then(() => {
        loading.close()
        this.dialogCalcType = false
        this.freshAllData()
        this.$notify({
          title: '成功',
          message: '修改成功！',
          type: 'success'
        })
      }).catch(e =>{
        console.log(e)
        loading.close()
      })
    }
  }
}
</script>

<style scoped>
</style>
